/* Built In Imports */
import NextLink from 'next/link';

/* External Imports */
import { Box, Flex, Link, Text } from '@chakra-ui/react';
import { render } from 'datocms-structured-text-to-html-string';

/* Internal Imports */
// Component
import SingleImage from '@components/Card/SingleImage';
import StructuredTextParser from '@components/Utility/ArticleParser/StructuredTextParser';
import { refineUrlDomain } from '@components/Utility/utils';

/* Services */

/**
 *
 * @param {Object} param0
 * @returns
 */
const SelfTransformation = ({ sectionContent, region, lang }) => {
  // consoleLog(sectionContent, 'video');
  return (
    <Box w="100%" m="0">
      <Box
        width="100%"
        m="0"
        background="#ffffff"
        paddingTop={{ md: '100px', base: '15px' }}
        paddingBottom={{ md: '80px', base: '40px' }}
        px={{ md: 'calc((100% - 720px)/2)', base: '15px' }}
      >
        <Flex flexDir={'column'} alignItems="center" justifyContent={'center'}>
          <Box className="sadhguruImage">
            <SingleImage
              my=""
              w="120px"
              maxWidth=""
              sectionContent={sectionContent[0]}
            />
          </Box>
          <Box className="sectionTitle">
            <StructuredTextParser
              str={render(sectionContent[1].body)}
              region={region}
              lang={lang}
            />
            <style>
              {`
                .sectionTitle p{
                  font-family: "FedraSansStd-medium", sans-serif;
    font-size: 42px;
    color: #151515;
    text-align: center;
                }
                .sectionText p{
                  font-family: "FedraSansStd-book", sans-serif;
    font-size: 36px;
    margin-bottom:20px;
    color: #000000;
    text-align: center;
                }
                .sectionQR p{
                  font-family: "FedraSansStd-medium", sans-serif;
    font-size: 24px;
    color: #000000;
                }
                .qrText p{
                  font-family: "FedraSansStd-medium", sans-serif;
    font-size: 40px;
    color: #351f15;
    margin-top: 20px;
    text-align: center;
                }
                @media only screen and (max-width: 767px) {
                  .sectionTitle p{
                    font-family: "FedraSansStd-medium", sans-serif;
    font-size: 24px;
    color: #151515;
    text-align: center;
          }
          .sectionText p{
                  font-family: "FedraSansStd-book", sans-serif;
    font-size: 20px;
    margin-bottom:20px;
    color: #000000;
    text-align: center;
                }
                .sectionQR p{
                  font-family: "FedraSansStd-medium", sans-serif;
    font-size: 15px;
    color: #000000;
                }
                .qrText p{
                  font-family: "FedraSansStd-medium", sans-serif;
    font-size: 28px;
    color: #351f15;
    margin-top: 20px;
    text-align: center;
                }
          }
                `}
            </style>
          </Box>
          <Box className="sectionText">
            <Text>{sectionContent[2].text}</Text>
          </Box>
          <Box
            width={{ base: '100%', sm: '373px' }}
            maxW="373px"
            textAlign="center"
            padding="30px 55px 27px 55px"
            borderRadius="8px"
            border="solid 1px #e9dcbe"
            backgroundColor="#ffffff"
          >
            <SingleImage
              w="100%"
              sectionContent={sectionContent[4]}
              my="0"
              mx="0"
              maxWidth="100%"
            />
            <Box className="sectionQR" textAlign="center" mt="10px">
              <Text>{sectionContent[3].text}</Text>
            </Box>
          </Box>
          <Box className="qrText" mb={'20px'}>
            <StructuredTextParser
              str={render(sectionContent[5].body)}
              region={region}
              lang={lang}
            />
          </Box>

          <Flex
            className="linkBlock"
            alignItems={'center'}
            justifyContent="center"
          >
            <NextLink
              href={refineUrlDomain(sectionContent[6]?.linkUrl, region, lang)}
              passHref
              m="0"
              legacyBehavior>
              <Link mr="10px">
                <SingleImage
                  my="0"
                  mx="0"
                  maxWidth="100%"
                  sectionContent={sectionContent[6]}
                />
              </Link>
            </NextLink>
            <NextLink
              href={refineUrlDomain(sectionContent[7]?.linkUrl, region, lang)}
              passHref
              legacyBehavior>
              <Link mr="10px">
                <SingleImage
                  my="0"
                  mx="0"
                  maxWidth="100%"
                  sectionContent={sectionContent[7]}
                />
              </Link>
            </NextLink>
          </Flex>
        </Flex>
      </Box>
    </Box>
  );
};

export default SelfTransformation;
